import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

export const userService = {
    searchUsers,
    updateUser,
    createUser
};
const baseUrl = `/api/users`;


function searchUsers(searchWords: string[], inactive: boolean): Promise<any>  {
    const object = {
        url: `${baseUrl}/search`,
        postBody: {searchWords: searchWords, inactive: inactive},
        customErrorMessage: `Failed to search users`,
    };
    return handleServiceRequest.post(object);
}

function updateUser(userId: string, firstName: string, lastName: string, email: string, inactive: boolean): Promise<any>  {
    const object = {
        url: `${baseUrl}/${userId}`,
        postBody: {FirstName: firstName, LastName: lastName, Email: email, Inactive: inactive},
        customHandleError: CustomEmailAlreadyTakenErrorHandler
    };
    return handleServiceRequest.put(object);
}

function createUser(firstName: string, lastName: string, email: string): Promise<any>  {
    const object = {
        url: `${baseUrl}`,
        postBody: {FirstName: firstName, LastName: lastName, Email: email},
        customHandleError: CustomEmailAlreadyTakenErrorHandler
    };
    return handleServiceRequest.post(object);
}

function CustomEmailAlreadyTakenErrorHandler(error: any) {
    if(error.response?.data?.problemDetails?.errors?.DuplicateEmail)
        NotificationService.error(error.response?.data?.problemDetails?.errors?.DuplicateEmail[0])
    else
        NotificationService.handleError(error)
}